var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"grid-list",style:({
    width: 100 / _vm.$parent.cols + '%',
    height: _vm.$parent.height ? _vm.$parent.height + 'px' : '',
  }),attrs:{"href":"javascript:;"}},[_c('div',{staticClass:"grid-icon",style:({
      background: _vm.$parent.iconBackground,
    })},[(_vm.hasIconSlot)?_vm._t("icon"):_vm._e(),(_vm.hasNumSlot)?_vm._t("num"):_vm._e(),(_vm.hasTopRightSlot)?_c('span',{staticClass:"top-right"},[_vm._t("topRight")],2):_vm._e()],2),(_vm.hasLabelSlot)?_c('p',{staticClass:"grid-label"},[_vm._t("label")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }